/** A real Telegram launch carries signed initData; SDK presence alone is not authentication. */
export function hasTelegramLaunchContext(initData: unknown): initData is string {
  return typeof initData === "string" && initData.length > 0;
}
